module.exports = {"home":"TOP","video":"動画","role":"武将","map":"戦国地図","summary":"ゲーム紹介","company":{"text1":"ジャンル:天下統一ストラテジー","text2":"価格:無料(アイテム課金あり)","text3":"お問合せ","text4":"個人情報取扱","text5":"利用規約","text6":"使用条款","text7":"特定商取引法に基づく表示"},"index":{"channel_text":"好評配信中！"},"new":{"all":"全部","tz":"お知らせ","wh":"メンテナンス","hd":"イベント","prev":"前へ","next":"次へ","news":"一覧に戻る","top":"TOP"},"phonetext":{"new":"最新情報","fb":"Twitter"}}


//////////////////
// WEBPACK FOOTER
// ./src/locales/ja.json
// module id = jc8P
// module chunks = 1